<template>
  <div>
    <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
      <el-col :span="null">
        <AppAvatar :size="60" :src="avatar"></AppAvatar>
      </el-col>
      <el-col :span="null" :style="{ flex: '1' }">
        <el-input
          :value="name || 'ไม่ระบุ'"
          :class="$style.input"
          readonly
          :disabled="!name"
          :style="{ marginBottom: '0.5rem' }"
        ></el-input>
        <div>
          <div :class="$style.infoLabel">
            Tel.
          </div>
          <div :class="$style.infoText">
            {{ tel || '-' }}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { AppAvatar } from '@/components/ui/avatar'

export default {
  components: { AppAvatar },

  props: {
    avatar: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    tel: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss" module>
.input {
  :global(.el-input__inner) {
    font-weight: bold;
    font-size: 1.25rem;
  }
}

.infoLabel {
  color: #5a5a5a;
  display: inline-block;
  margin-right: 0.5rem;
}

.infoText {
  color: #354052;
  display: inline-block;
  font-weight: bold;
}
</style>
